import { EyewitnessPost, PostPetition } from "../interface/api";

export function report_validate(petitionData: EyewitnessPost): {
    bool: boolean;
    text: string;
  } {
    if (petitionData.post_type === "") {
      return { bool: false, text: "Post Type is required" };
    }
    if (petitionData.title === "") {
      return { bool: false, text: "Title is required" };
    }
    if (petitionData.context === "") {
      return { bool: false, text: "Context is required" };
    }
  
    if (petitionData.media.length === 0) {
      return { bool: false, text: "Media is required, atleast One" };
    }
  
    return { bool: true, text: "" };
  }


  export function petition_validate(petitionData: PostPetition): {
    bool: boolean;
    text: string;
  } {
    if (petitionData.post_type === "") {
      return { bool: false, text: "Post Type is required" };
    }
    if (petitionData.title === "") {
      return { bool: false, text: "Title is required" };
    }
    if (petitionData.context === "") {
      return { bool: false, text: "Context is required" };
    }
  
    // if (petitionData.representative_info.id === 0) {
    //   return { bool: false, text: "Target Representative ID is required" };
    // }
    // if (petitionData.media.length === 0) {
    //   return { bool: false, text: "Media is required, atleast One" };
    // }
  
    return { bool: true, text: "" };
  }